export class OrderingData {
    column : string;
    descending : boolean;
}
